import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";

export type UserInfo = {
  email: string;
  username: string;
  displayName: string;
  isDeveloper?: boolean; // Is set to optional just because of compatibility with `const storage = createJSONStorage<UserInfo>(() => localStorage);`
  roles?: string[]; // TODO: Make this not optional
};

/**
 * Fetch the current user info.
 * @throws `UnauthorizedUser` if backend returns 403 (user is authenticated but lacks permissions).
 */
export const fetchUserInfo = async (): Promise<UserInfo> => {
  const response = await axiosClient.get<UserInfo>(`${getBackendUrl()}/user`);
  return response.data;
};
